var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"full-height align-baseline rounded card-margins"},[_c('v-card-title',{staticClass:"title"},[_vm._t("title"),_c('v-spacer')],2),_c('v-card-text',{class:{ 'px-0': _vm.containsChart }},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }